import React from "react";
import { styled } from "@styles";
import { subtitle1, caption, h7, body2 } from '@typo/typo.module.css';
import { textPrimary, textSecondary, mainPrimary } from '@typo/color.module.css';
import { vouchers_availableVouchers_edges_node } from "@molecules/MyVoucherModal/__generated__/vouchers";
import { maccaronDateForm } from "@utils";
import { Link } from "react-router-dom";
import { productListByVoucher } from "@src/app/routes";

interface IProps {
  item: vouchers_availableVouchers_edges_node;
  onClickVoucher: (value: string) => void;
  showProduct: Boolean | false;
  isSelected?: boolean;
}

interface WrapperProps {
  isSelected: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const Wrapper = styled.div<WrapperProps>`
  padding: 1rem;
  &:hover {
    background-color: #2837490A;
  }
  ${(props) => props.isSelected &&
    `
     border: 1px solid #FF3399;
     border-radius: 6px; 
    `}
`;

const WrapperWithBorder = styled.div`
  padding: 1rem;
  border: 1px solid #7878781F;
  &:hover {
    background-color: #2837490A;
  }
  margin-top: 1rem;
`;

const DateAndCode = styled.div`
  height: 2rem;
`;

const VoucherName = styled.div`
  text-align: left;
`;

const EndDate = styled.span`
  float: left;
`;

const VoucherCode = styled.span`
  float: right;
`;

const Hr = styled.hr`
  margin: 0.5rem 0;
`;

const ApplicableProducts = styled.div`
  text-align: center;
`;

const Voucher: React.FC<IProps> = ({
  item,
  onClickVoucher,
  showProduct,
  isSelected
}: IProps) => {
  const handleVoucherClick = () => {
    if (showProduct) {

    } else {
      onClickVoucher(item.code);
    }
  }
  return (
    <>
      {
        showProduct ? (
          <WrapperWithBorder onClick={handleVoucherClick}>
            <VoucherName>
              <p className={[subtitle1, textPrimary].join(' ')}>{item.name}</p>
            </VoucherName>
            <DateAndCode>
              <EndDate className={[caption, textSecondary].join(' ')}>{`Available till ${maccaronDateForm(item.endDate, 'dd MMM yyyy')}`}</EndDate>
              <VoucherCode className={[h7, mainPrimary].join(' ')}>{item.code}</VoucherCode>
            </DateAndCode>
            <Hr />
            <ApplicableProducts>
              {
                item.type == ('VALUE' || 'SHIPPING') ? (
                  <p className={[body2, textSecondary].join(' ')}>Applicable to All Products</p>
                ) : (
                  <Link
                    to={productListByVoucher.replace(':voucherCode', item.code)}
                    className={[body2, mainPrimary].join(' ')}
                  >
                    Applicable Products &gt;
                  </Link>
                )
              }
            </ApplicableProducts>
          </WrapperWithBorder>
        ) : (
          <>
            <Wrapper onClick={handleVoucherClick} isSelected={isSelected}>
              <VoucherName>
                <p className={[subtitle1, textPrimary].join(' ')}>{item.name}</p>
              </VoucherName>
              <DateAndCode>
                <EndDate className={[caption, textSecondary].join(' ')}>{`Available till ${maccaronDateForm(item.endDate, 'dd MMM yyyy')}`}</EndDate>
                <VoucherCode className={[h7, mainPrimary].join(' ')}>{item.code}</VoucherCode>
              </DateAndCode>
            </Wrapper>
            <Hr />
          </>
        )
      }

    </>
  );
};

export { Voucher };